/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_NavInputs */

const id_billing_nav = /** @type {(inputs: Billing_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagihan`)
};

const en_billing_nav = /** @type {(inputs: Billing_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing`)
};

/**
* | output |
* | --- |
* | "Billing" |
*
* @param {Billing_NavInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_nav = /** @type {((inputs?: Billing_NavInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_NavInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_nav(inputs)
	return id_billing_nav(inputs)
});